module.exports = __webpack_public_path__ + "static/media/thumbnail.48d21827.jpg";